import React, { useState } from "react";
import { Modal } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDay } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Agendados } from "./Agendados";
import { CompromissosDisponiveis } from "./CompromissosDisponiveis";
import { IComponentModal } from "../../Modais/IModalComponent";
import ModalComponent from "../../Modais";
import useAsyncEffect from "../../../hooks/useAsyncEffect";
import {
    ListarAgendamentosController,
    ListarCompromissoDisponiveisVistoriaAgendaController,
} from "../../../Controllers/AssistenciaTecnica/Agendamento/AgendamentoControllers";
import {
    IAgendaCompromisso,
    ICompromissosDisponiveis,
    IFiltroListarAgendamento,
} from "../../../Interfaces/AssistenciaTecnica/Agendamento/AgendamentoInterfaces";
import { MoreLinkArg } from "@fullcalendar/react";
interface IFiltrosDeAgendamento
    extends Omit<
        IFiltroListarAgendamento,
        "DT_INICIO" | "DT_FIM" | "FL_APENAS_MEUS_AGENDAMENTOS"
    > {}
interface IModalInterface {
    filtroListarAgendamento: IFiltrosDeAgendamento;
    setShow: (show: boolean) => void;
    arg: MoreLinkArg;
}
export function EventoModalGrupoHeader(arg: any) {
    return (
        <>
            <Modal.Title
                id="contained-modal-title-vcenter"
                className="card-title"
            >
                <div className="d-flex ">
                    <FontAwesomeIcon icon={faCalendarDay} className="mr-2" />
                    <h3 className="card-label">
                        Eventos de{" "}
                        {moment(arg.hiddenSegs[0].start).format("LL")}
                    </h3>
                </div>
            </Modal.Title>
            <div className="card-toolbar">
                <ul
                    className="nav nav-tabs nav-bold nav-tabs-line"
                    role="tablist"
                    id="#GrupoTools"
                >
                    <li className="nav-item">
                        <a
                            className="nav-link active"
                            href="#Agendados"
                            data-toggle="tab"
                            data-target="#Agendados"
                            role="tab"
                        >
                            <span className="nav-text">Agendados</span>
                        </a>
                    </li>
                    <li className="nav-item">
                        <a
                            className="nav-link"
                            href="#CompromissosDisponiveis"
                            data-toggle="tab"
                            data-target="#CompromissosDisponiveis"
                        >
                            <span className="nav-text">
                                Compromissos Disponíveis
                            </span>
                        </a>
                    </li>
                </ul>
            </div>
        </>
    );
}

function EventosModal(props: IModalInterface) {
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const { value: lstAgendamentos, loading: lstAgendamentosLoading } =
        useAsyncEffect(async () => {
            const diaSeguinteData = moment(props.arg.hiddenSegs[0].end)
                .add(1, "days")
                .startOf("day");
            const validateDataFimSemana: any =
                props.arg.view.type === "timeGridWeek"
                    ? diaSeguinteData
                    : props.arg.hiddenSegs[0].end;
            const lstAgendamentos: IAgendaCompromisso[] = [];
            await ListarAgendamentosController({
                ...props.filtroListarAgendamento,
                DT_INICIO: props.arg.hiddenSegs[0].start,
                DT_FIM: validateDataFimSemana,
                FL_APENAS_MEUS_AGENDAMENTOS: false,
            }).then((res) => {
                return res.map((v) =>
                    v.COMPROMISSOS.map((value) => {
                        return lstAgendamentos.push(value);
                    })
                );
            });
            return lstAgendamentos;
        }, []);

    const {
        value: lstCompromissosDisponiveis,
        loading: lstCompromissosDisponiveisLoading,
    } = useAsyncEffect(async () => {
        const diaSeguinteData = moment(props.arg.hiddenSegs[0].end)
            .add(1, "days")
            .startOf("day");
        const validateDataFimSemana =
            props.arg.view.type === "timeGridWeek"
                ? diaSeguinteData.format()
                : props.arg.hiddenSegs[0].end.toISOString();

        const lstCompromissosDisponiveis: ICompromissosDisponiveis[] = [];
        await ListarCompromissoDisponiveisVistoriaAgendaController(
            props.arg.hiddenSegs[0].start.toISOString(),
            validateDataFimSemana,
            props.filtroListarAgendamento.ID_TIPO_COMPROMISSO,
            props.filtroListarAgendamento.ID_PRODUTO,
            props.filtroListarAgendamento.ID_USUARIO
        ).then((res) => {
            return res.map((v) =>
                v.COMPROMISSOS.map((value) => {
                    return lstCompromissosDisponiveis.push(value);
                })
            );
        });
        return lstCompromissosDisponiveis;
    }, []);
    return (
        <>
            <div className="tab-content" id="GrupoTools">
                <div
                    className="tab-pane fade active show"
                    id="Agendados"
                    role="tabpanel"
                    aria-labelledby="Agendados"
                >
                    <Agendados
                        setShow={setShow}
                        setModal={setModal}
                        lstAgendamentos={lstAgendamentos}
                        lstAgendamentosLoading={lstAgendamentosLoading}
                    />
                </div>
                <div
                    className="tab-pane fade"
                    id="CompromissosDisponiveis"
                    role="tabpanel"
                    aria-labelledby="CompromissosDisponiveis"
                >
                    <CompromissosDisponiveis
                        setShow={setShow}
                        setModal={setModal}
                        lstCompromissosDisponiveis={lstCompromissosDisponiveis}
                        lstCompromissosDisponiveisLoading={
                            lstCompromissosDisponiveisLoading
                        }
                    />
                </div>
            </div>
            <ModalComponent
                show={show}
                setShow={setShow}
                ModalComponent={modal}
            />
        </>
    );
}
export default EventosModal;
